/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForAzureSubscription extends models.ServiceAccountCredentialsBaseForAzureApplication {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForAzureSubscription");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForAzureSubscription.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForAzureSubscription>): ServiceAccountCredentialsForAzureSubscription {
        let obj = Object.assign(new ServiceAccountCredentialsForAzureSubscription(), model);
        ServiceAccountCredentialsForAzureSubscription.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForAzureSubscription>): ServiceAccountCredentialsForAzureSubscription {
        if (!model) return null;
        return ServiceAccountCredentialsForAzureSubscription.newInstance(<ServiceAccountCredentialsForAzureSubscription> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForAzureSubscription) {
        if (!obj) return;

        models.ServiceAccountCredentialsForAzureSubscription.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForAzureSubscription): boolean {
        if (models.ServiceAccountCredentialsBaseForAzureApplication.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForAzureSubscription.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
